import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Palvelut from "./pages/palvelut";
import Hinnasto from "./pages/hinnasto";
import OtaYhteytta from "./pages/otayhteytta";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <main className="content">
          <Routes>
            <Route path="/" element={<Palvelut />} />
            <Route path="/palvelut" element={<Palvelut />} />
            <Route path="/hinnasto" element={<Hinnasto />} />
            <Route path="/otayhteytta" element={<OtaYhteytta />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
